module.exports = __webpack_public_path__ + "static/mailIcon-c51baaa9b2eeec0a625c4a6f28df6ca9.svg";